<template>
  <div class="card-container" style="background: #f0f2f5; padding: 0 15px">
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>超级智能体工作站</el-breadcrumb-item>
        <el-breadcrumb-item>减重智能体</el-breadcrumb-item>
        <el-breadcrumb-item>居家运动处方</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="margin-bottom: 1vh; padding: 0px 0px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/index' }">&lt;</el-breadcrumb-item> -->
        <i class="el-icon-back" style="font-size: 20px; font-weight: bolder" @click="back()"></i>
      </el-breadcrumb>
    </div>
    <el-button-group style="margin-bottom: 10px">
      <el-button class="healthButton" @click="click(0)">数字档案</el-button>
      <el-button class="healthButton" @click="click(1)">运动评估</el-button>
      <el-button class="healthButton healthActive" @click="click(2)">运动处方</el-button>
      <el-button class="healthButton" @click="click(3)">营养处方</el-button>
      <el-button class="healthButton" @click="click(4)">行为认知治疗</el-button>
      <el-button class="healthButton" @click="click(5)">药物方案</el-button>
      <el-button class="healthButton" @click="click(6)">临床随访</el-button>
    </el-button-group>

    <div class="card">
      <div class="left">
        <div class="person">
          <div class="title"></div>
          <div class="img">
            <div>
              <img src="@/page/login/images/personal.png" />
            </div>
          </div>
          <div class="name">{{ info.name }}</div>
          <div class="body">
            <div class="th">
              <div class="td">性别：</div>
              <div class="tr">{{ info.sex === 1 ? "男" : info.sex === 2 ? "女" : "未填写" }}</div>
            </div>
            <div class="th">
              <div class="td">手 机 号 码：</div>
              <div class="tr">{{ info.mobile }}</div>
            </div>
            <div class="th">
              <div class="td">身高 | 体重：</div>
              <div class="tr">{{ info.height ? info.height : " " }}cm | {{ info.weight ? info.weight : " " }}kg</div>
            </div>
            <div class="th">
              <div class="td">年龄 | 生日：</div>
              <div class="tr">{{ info.age }}岁 | 未填写</div>
            </div>
            <div class="th">
              <div class="td">生 成 时 间：</div>
              <div class="tr">{{ schemeExercise.reportTime ? schemeExercise.reportTime : "用户未生成本周临床营养指导" }}</div>
            </div>
            <div class="th">
              <div class="td">身 份 证 号：</div>
              <div class="tr">{{ info.idCard }}</div>
            </div>
          </div>
        </div>

        <div class="plan">
          <div class="title">
            <img src="@/page/login/images/plan.png" />
            <div>特别注意提示</div>
          </div>
          <div class="body">
            <div v-for="(item, index) in schemeExercise.specialNotes" :key="index">{{ item }}</div>
            <!-- <div>1、低胆固醇饮食，控制饱和脂肪摄入，改善血脂异常；</div>
            <div>2、限盐（每日钠摄入＜2000mg），保护肾脏功能，预防高血压进展</div>
            <div>3、适量优质蛋白摄入，减轻肾脏负担，避免高蛋白加重肾损伤</div>
            <div>4、增加膳食纤维和钾摄入，帮助调节血脂、促进肠道健康、对抗骨质疏松</div>
            <div>5、禁酒，减少肝脏代谢负担，延缓非酒精性脂肪肝进展</div>
            <div>6、控制总热量，维持健康体重，改善脂肪肝和代谢紊乱</div>
            <div>7、避免高嘌呤食物，预防尿酸升高及泌尿系结石复发</div>-->
          </div>
        </div>
      </div>
      <div class="right">
        <div class="chuF">
          <div class="title">
            <div :class="chuFshow == 1 ? 'active' : ''" @click="changeChuF(1)">运动方案</div>
            <div :class="chuFshow == 2 ? 'active' : ''" @click="changeChuF(2)">运动计划</div>
            <div :class="chuFshow == 3 ? 'active' : ''" @click="changeChuF(3)">运动处方</div>
          </div>
          <template v-if="chuFshow == 1">
            <div class="content">
              <div class="name">
                <div class="icon h1"></div>
                <div class="dt">运动目的</div>
              </div>
              <div class="card" style="flex-direction: column">
                <div v-for="(item, index) in schemeExercise.specialNotes" :key="index">{{ item }}</div>
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h2"></div>
                <div class="dt">运动频率</div>
              </div>
              <div class="card">
                {{ schemeExercise.schemeExerciseNew.sportsFrequency ? schemeExercise.schemeExerciseNew.sportsFrequency : "" }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h3"></div>
                <div class="dt">运动强度</div>
              </div>
              <div class="card">
                有氧运动：{{ schemeExercise.schemeExerciseNew.aerobicExercise ? schemeExercise.schemeExerciseNew.aerobicExercise : "" }}
                <br />
                力量运动：{{ schemeExercise.schemeExerciseNew.strengthTrain ? schemeExercise.schemeExerciseNew.strengthTrain : "" }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h4"></div>
                <div class="dt">运动时间</div>
              </div>
              <div class="card">
                总时长：{{ schemeExercise.schemeExerciseNew.totalDuration ? schemeExercise.schemeExerciseNew.totalDuration : "" }}
                <br />
                结构包括：{{ schemeExercise.schemeExerciseNew.structure ? schemeExercise.schemeExerciseNew.structure : "" }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h5"></div>
                <div class="dt">每周每天运动类型推荐</div>
              </div>
              <div class="card">
                有氧类：{{ schemeExercise.schemeExerciseNew.homeAerobic ? schemeExercise.schemeExerciseNew.homeAerobic : "" }}
                <br />
                力量类：{{ schemeExercise.schemeExerciseNew.homePower ? schemeExercise.schemeExerciseNew.homePower : "" }}
                <br />
                柔韧类：{{ schemeExercise.schemeExerciseNew.homeFlexible ? schemeExercise.schemeExerciseNew.homeFlexible : "" }}
                <br />
                机构运动项目：{{ schemeExercise.schemeExerciseNew.mechanismMotion ? schemeExercise.schemeExerciseNew.mechanismMotion : "" }}
              </div>
            </div>
          </template>
          <template v-if="chuFshow == 2">
            <div class="content">
              <div class="name">
                <div class="icon h1"></div>
                <div class="dt">适应期 (第1-4周)</div>
              </div>
              <div class="card">
                运动时间：{{ schemeExercise.schemeExerciseNew.adaptTime ? schemeExercise.schemeExerciseNew.adaptTime : "" }}
                <br />
                运动频率：{{ schemeExercise.schemeExerciseNew.adaptFrequency ? schemeExercise.schemeExerciseNew.adaptFrequency : "" }}
                <br />
                运动强度：{{ schemeExercise.schemeExerciseNew.adaptIntensity ? schemeExercise.schemeExerciseNew.adaptIntensity : "" }}
                <br />
                目标能耗/次：{{ schemeExercise.schemeExerciseNew.adaptEnergyConsumption ? schemeExercise.schemeExerciseNew.adaptEnergyConsumption : "" }}
                <br />
                具体目标：{{ schemeExercise.schemeExerciseNew.adaptTarget ? schemeExercise.schemeExerciseNew.adaptTarget : "" }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h2"></div>
                <div class="dt">强化期 (第5-12周)</div>
              </div>
              <div class="card">
                运动时间：{{ schemeExercise.schemeExerciseNew.reinforcementTime ? schemeExercise.schemeExerciseNew.reinforcementTime : "" }}
                <br />
                运动频率：{{ schemeExercise.schemeExerciseNew.reinforcementFrequency ? schemeExercise.schemeExerciseNew.reinforcementFrequency : "" }}
                <br />
                运动强度：{{ schemeExercise.schemeExerciseNew.reinforcementIntensity ? schemeExercise.schemeExerciseNew.reinforcementIntensity : "" }}
                <br />
                目标能耗/次：{{ schemeExercise.schemeExerciseNew.reinforcementEnergyConsumption ? schemeExercise.schemeExerciseNew.reinforcementEnergyConsumption : "" }}
                <br />
                具体目标：{{ schemeExercise.schemeExerciseNew.reinforcementTarget ? schemeExercise.schemeExerciseNew.reinforcementTarget : "" }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h3"></div>
                <div class="dt">稳定期 (第13周及以后)</div>
              </div>
              <div class="card">
                运动时间：{{ schemeExercise.schemeExerciseNew.stableTime ? schemeExercise.schemeExerciseNew.stableTime : "" }}
                <br />
                运动频率：{{ schemeExercise.schemeExerciseNew.stableFrequency ? schemeExercise.schemeExerciseNew.stableFrequency : "" }}
                <br />
                运动强度：{{ schemeExercise.schemeExerciseNew.stableIntensity ? schemeExercise.schemeExerciseNew.stableIntensity : "" }}
                <br />
                目标能耗/次：{{ schemeExercise.schemeExerciseNew.stableEnergyConsumption ? schemeExercise.schemeExerciseNew.stableEnergyConsumption : "" }}
                <br />
                具体目标：{{ schemeExercise.schemeExerciseNew.stableTarget ? schemeExercise.schemeExerciseNew.stableTarget : "" }}
              </div>
            </div>
          </template>

          <template v-if="chuFshow == 3">
            <div style="display: flex; margin-top: 20px">
              <div style="position: relative">
                <div style="margin-bottom: 10px">运动处方生成时间: {{ reportDate }}</div>
                <div id="pdf-content" class="prescription-container">
                  <h1>{{ info.channel }}运动处方</h1>

                  <table class="info-table" style="text-align: center">
                    <tr>
                      <td style="width: 25mm">姓名</td>
                      <td style="width: 40mm">
                        <input style="width: 35mm" v-model="info.name" />
                      </td>
                      <td style="width: 15mm">性别</td>
                      <td style="width: 15mm">
                        <input style="width: 15mm" v-model="info.gender" />
                      </td>
                      <td style="width: 15mm">年龄</td>
                      <td style="width: 15mm">
                        <input style="width: 15mm" v-model="info.age" />
                      </td>
                      <td style="width: 20mm">联系电话</td>
                      <td>
                        <input style="width: 25mm" v-model="info.mobile" />
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 25mm">身份证</td>
                      <td style="width: 40mm">
                        <input style="width: 40mm" v-model="info.idCard" />
                      </td>
                      <td style="width: 15mm">病史</td>
                      <td colspan="3" style="width: 45mm">
                        <!-- {{ formData.medicalHistory }} -->
                        <input style="width: 25mm" v-model="formData.medicalHistory" />
                      </td>
                      <td style="width: 20mm">使用药物</td>
                      <td>
                        <div contenteditable="true" style="width: 40mm; font-family: inherit; font-size: 12px; word-break: break-all; white-space: pre-wrap; outline: none" @input="formData.drug = $event.target.innerText" v-html="formData.drug"></div>
                      </td>
                    </tr>
                  </table>
                  <!-- 运动前筛查 -->
                  <div class="model" style>
                    <h2>运动前筛查</h2>
                    <table class="data-table" style>
                      <tr>
                        <td style="width: 30mm; text-align: center">体力活动水平</td>
                        <td>
                          <span style="margin-left: 10mm" @click="chickActivityLevel(1)"> {{ formData.activityLevel == 1 ? "☑" : "☐" }} 需医师许可 </span>
                          <span style="margin-left: 15mm" @click="chickActivityLevel(2)"> {{ formData.activityLevel == 2 ? "☑" : "☐" }} 可以安全运动</span>
                          <!-- <span style="margin-left: 15mm" @click="chickActivityLevel(3)"> {{ formData.activityLevel == 3 ? "☑" : "☐" }} 正常 </span> -->
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div style="display: flex">
                            <div style="margin-left: 3mm; width: 22mm; font-weight: bold">健康筛查:</div>
                            <div style="margin-left: 0mm; width: 25mm; display: flex">
                              身高:
                              <input style="width: 8mm" v-model="info.height" />
                              cm
                            </div>
                            <div style="margin-left: 10mm; width: 25mm">
                              体重:
                              <input style="width: 8mm" v-model="info.weight" />
                              kg
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div style="display: flex; font-size: 14px">
                            <div style="margin-left: 25mm; width: 45mm">
                              空腹血糖:
                              <input style="width: 25mm; text-align: left" v-model="formData.bs" />
                            </div>
                            <div style="margin-left: 5mm; width: 45mm">
                              血压:
                              <input style="width: 30mm; text-align: left" v-model="formData.bp" />
                            </div>
                            <div style="margin-left: 5mm; width: 45mm">
                              脉搏:
                              <input style="width: 30mm; text-align: left" v-model="formData.hr" />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div style="display: flex">
                            <div style="margin-left: 25mm; width: 45mm">
                              总胆固醇:
                              <input style="width: 25mm; text-align: left" v-model="formData.cho" />
                            </div>
                            <div style="margin-left: 5mm; width: 30mm">
                              甘油三脂:
                              <input style="width: 8mm" v-model="formData.triglyceride" />
                            </div>
                            <div style="margin-left: 5mm; width: 35mm">
                              高密度脂蛋白:
                              <input style="width: 8mm" v-model="formData.slm1" />
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div style="display: flex">
                            <div style="margin-left: 25mm; width: 30mm">
                              体脂率:
                              <input style="width: 15mm; text-align: left" v-model="formData.fat_rate" />
                            </div>
                            <div style="margin-left: 3mm; width: 40mm">
                              脂肪量:
                              <input style="width: 20mm; text-align: left" v-model="formData.fat" />
                            </div>
                            <div style="margin-left: 3mm; width: 40mm">
                              肌肉量：
                              <input style="width: 20mm; text-align: left" v-model="formData.slm" />
                            </div>
                            <div style="margin-left: 0mm; width: 45mm">
                              内脏脂肪面积
                              <input style="width: 20mm; text-align: left" v-model="formData.vfa" />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <!-- 医学检查 -->
                  <div class="model" style>
                    <h2>运动医学检查</h2>
                    <table class="data-table" style>
                      <tr>
                        <td style="width: 25mm; text-align: center">运动风险等级</td>
                        <td colspan="2">
                          <span style="padding-left: 15mm" @click="ydfxdj(3)">
                            {{ formData.ydfxdj == 4 ? "☑" : "☐" }}
                            高
                          </span>
                          <span style="padding-left: 15mm" @click="ydfxdj(2)">
                            {{ formData.ydfxdj == 3 ? "☑" : "☐" }}
                            中高
                          </span>
                          <span style="padding-left: 15mm" @click="ydfxdj(4)">
                            {{ formData.ydfxdj == 2 ? "☑" : "☐" }}
                            中低
                          </span>
                          <span style="padding-left: 15mm" @click="ydfxdj(1)">
                            {{ formData.ydfxdj == 1 ? "☑" : "☐" }}
                            低
                          </span>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="2" style="margin-left: 10mm">
                          <div style="display: flex">
                            <div style="margin-left: 3mm; width: 25mm; font-weight: bold">运动测试结果</div>
                          </div>
                        </td>
                      </tr>
                      <tr style="width: 30mm">
                        <td style="text-align: center">心肺功能</td>
                        <td>
                          <div style="display: flex">
                            <div style="margin-left: 10mm; width: 22mm" @click="xfgn(1)">{{ formData.xfgn == 1 ? "■" : "☐" }} 极重度受限</div>
                            <div style="margin-left: 10mm; width: 22mm" @click="xfgn(2)">{{ formData.xfgn == 2 ? "■" : "☐" }} 重度受限</div>
                            <div style="margin-left: 10mm; width: 22mm" @click="xfgn(3)">{{ formData.xfgn == 3 ? "■" : "☐" }} 中重度受限</div>
                            <div style="margin-left: 10mm; width: 28mm" @click="xfgn(4)">{{ formData.xfgn == 4 ? "■" : "☐" }} 正常/轻度受限</div>
                          </div>
                        </td>
                      </tr>
                      <tr style="width: 30mm">
                        <td style="text-align: center">肌肉力量</td>
                        <td>
                          <div style="display: flex">
                            <div style="margin-left: 10mm; width: 12mm" @click="jrll(1)">{{ formData.jrll == 1 ? "■" : "☐" }} 差</div>
                            <div style="margin-left: 10mm; width: 12mm" @click="jrll(2)">{{ formData.jrll == 2 ? "■" : "☐" }} 较差</div>
                            <div style="margin-left: 10mm; width: 12mm" @click="jrll(3)">{{ formData.jrll == 3 ? "■" : "☐" }} 一般</div>
                            <div style="margin-left: 10mm; width: 12mm" @click="jrll(4)">{{ formData.jrll == 4 ? "■" : "☐" }} 良好</div>
                            <div style="margin-left: 10mm; width: 12mm" @click="jrll(5)">{{ formData.jrll == 5 ? "■" : "☐" }} 优秀</div>
                          </div>
                        </td>
                      </tr>
                      <tr style="width: 30mm">
                        <td style="text-align: center">体成分</td>
                        <td>
                          <div style="display: flex">
                            <div style="margin-left: 10mm; width: 12mm" @click="tcf(1)">{{ formData.tcf == 1 ? "■" : "☐" }} 差</div>
                            <div style="margin-left: 10mm; width: 12mm" @click="tcf(2)">{{ formData.tcf == 2 ? "■" : "☐" }} 较差</div>
                            <div style="margin-left: 10mm; width: 22mm" @click="tcf(3)">{{ formData.tcf == 3 ? "■" : "☐" }} 优秀/良好</div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <!-- 运动处方 -->
                  <div class="model" style>
                    <h2>
                      <!-- 运动处方 -->
                      运动方案（FITT原则）
                    </h2>
                    <table class="data-table" style>
                      <tr>
                        <td style="width: 25mm; text-align: center">运动目的</td>
                        <td colspan="7" style="font-size: 12px">
                          <div contenteditable="true" style="width: 140mm; line-height: 1.6; padding: 4px; font-family: inherit; font-size: 12px; word-break: break-all; white-space: pre-wrap; outline: none" @input="formData.purposes = $event.target.innerText" v-html="formData.purposes"></div>

                          <!-- <div style="width: 140mm; line-height: 1.6; padding: 4px; font-family: inherit; font-size: 12px; word-break: break-all; white-space: pre-wrap; outline: none">{{ formData.purposes }}</div> -->
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 25mm; text-align: center">运动频率</td>
                        <td colspan="7" style="font-size: 12px">
                          <div contenteditable="true" style="width: 140mm; line-height: 1.6; padding: 4px; font-family: inherit; font-size: 12px; word-break: break-all; white-space: pre-wrap; outline: none" @input="formData.frequency = $event.target.innerText" v-html="formData.frequency"></div>

                          <!-- <div style="width: 140mm; line-height: 1.6; padding: 4px; font-family: inherit; font-size: 12px; word-break: break-all; white-space: pre-wrap; outline: none">{{ formData.frequency }}</div> -->
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 25mm; text-align: center">运动强度</td>
                        <td colspan="7" style="font-size: 12px">
                          <div contenteditable="true" style="width: 140mm; line-height: 1.6; padding: 4px; font-family: inherit; font-size: 12px; word-break: break-all; white-space: pre-wrap; outline: none" @input="formData.strength = $event.target.innerText" v-html="formData.strength"></div>

                          <!-- <div style="width: 140mm; line-height: 1.6; padding: 4px; font-family: inherit; font-size: 12px; word-break: break-all; white-space: pre-wrap; outline: none">{{ formData.strength }}</div> -->
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 25mm; text-align: center">运动时间</td>
                        <td colspan="7" style="font-size: 12px">
                          <div contenteditable="true" style="width: 140mm; line-height: 1.6; padding: 4px; font-family: inherit; font-size: 12px; word-break: break-all; white-space: pre-wrap; outline: none" @input="formData.time = $event.target.innerText" v-html="formData.time"></div>

                          <!-- <div style="width: 140mm; line-height: 1.6; padding: 4px; font-family: inherit; font-size: 12px; word-break: break-all; white-space: pre-wrap; outline: none">{{ formData.time }}</div> -->
                        </td>
                      </tr>
                    </table>
                    <table class="data-table motion-project-table" style>
                      <tr>
                        <td colspan="8">
                          <div style="display: flex">
                            <div style="margin-left: 3mm; font-weight: bold">机构运动项目</div>
                          </div>
                        </td>
                      </tr>
                      <tr style="text-align: center">
                        <td style="width: 43mm" colspan="2">名称</td>
                        <td style="width: 15mm">频率</td>
                        <td style="width: 27mm">时间/次数</td>
                        <td style="width: 43mm" colspan="2">名称</td>
                        <td style="width: 15mm">频率</td>
                        <td style="width: 27mm">时间/次数</td>
                      </tr>

                      <tr style="text-align: center" v-for="index in 2" :key="index">
                        <td style="width: 43mm" colspan="2">
                          <input style="width: 42mm" v-model="mechanismMotion[index * 2 - 2].motionName" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" v-model="mechanismMotion[index * 2 - 2].motionFrequency" />
                        </td>
                        <td style="width: 27mm">
                          <input style="width: 26mm" v-model="mechanismMotion[index * 2 - 2].motionTime" />
                        </td>
                        <td style="width: 43mm" colspan="2">
                          <input style="width: 42mm" v-model="mechanismMotion[index * 2 - 1].motionName" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" v-model="mechanismMotion[index * 2 - 1].motionFrequency" />
                        </td>
                        <td style="width: 27mm">
                          <input style="width: 26mm" v-model="mechanismMotion[index * 2 - 1].motionTime" />
                        </td>
                      </tr>
                    </table>
                    <div class="motion-project-page-spacer"></div>
                    <table class="data-table motion-project-table" style>
                      <tr>
                        <td colspan="8">
                          <div style="display: flex">
                            <div style="margin-left: 3mm; font-weight: bold">居家运动项目</div>
                          </div>
                        </td>
                      </tr>
                      <tr style="text-align: center">
                        <td style="width: 43mm" colspan="2">名称</td>
                        <td style="width: 15mm">频率</td>
                        <td style="width: 27mm">时间/次数</td>
                        <td style="width: 43mm" colspan="2">名称</td>
                        <td style="width: 15mm">频率</td>
                        <td style="width: 27mm">时间/次数</td>
                      </tr>

                      <tr style="text-align: center" v-for="index in 3" :key="index">
                        <td style="width: 43mm" colspan="2">
                          <input style="width: 42mm" v-model="homeMotion[index * 2 - 2].motionName" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" v-model="homeMotion[index * 2 - 2].motionFrequency" />
                        </td>
                        <td style="width: 27mm">
                          <input style="width: 26mm" v-model="homeMotion[index * 2 - 2].motionTime" />
                        </td>
                        <!-- <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td> -->
                        <td style="width: 43mm" colspan="2">
                          <input style="width: 42mm" v-model="homeMotion[index * 2 - 1].motionName" />
                        </td>
                        <td style="width: 15mm">
                          <input style="width: 14mm" v-model="homeMotion[index * 2 - 1].motionFrequency" />
                        </td>
                        <td style="width: 27mm">
                          <input style="width: 26mm" v-model="homeMotion[index * 2 - 1].motionTime" />
                        </td>
                        <!-- <td style="width: 15mm">
                          <input style="width: 14mm" />
                        </td> -->
                      </tr>

                      <tr>
                        <td colspan="8">
                          <div style="display: flex">
                            <div style="margin-left: 3mm; font-weight: bold">运动计划</div>
                          </div>
                        </td>
                      </tr>

                      <!-- <tr class="plan" style="text-align: center">
                        <td style="width: 30mm">适应期</td>
                        <td colspan="7">
                          目标能耗:
                          <input style="width: 40mm" v-model="adapt.energyConsumption" />
                          <br />
                          运动时间:
                          <input style="width: 50mm" v-model="adapt.time" />
                          运动频率:
                          <input style="width: 60mm" v-model="adapt.frequency" />
                          <br />
                          运动强度:
                          <input style="width: 128mm" v-model="adapt.intensity" />
                        </td>
                      </tr>
                      <tr class="plan" style="text-align: center">
                        <td style="width: 30mm">强化期</td>
                        <td colspan="7">
                          目标能耗:
                          <input style="width: 40mm" v-model="reinforcement.energyConsumption" />
                          <br />
                          运动时间:
                          <input style="width: 50mm" v-model="reinforcement.time" />
                          运动频率:
                          <input style="width: 60mm" v-model="reinforcement.frequency" />
                          <br />
                          运动强度:
                          <input style="width: 128mm" v-model="reinforcement.intensity" />
                        </td>
                      </tr>
                      <tr class="plan" style="text-align: center">
                        <td style="width: 30mm">稳定期</td>
                        <td colspan="7">
                          目标能耗:
                          <input style="width: 40mm" v-model="stable.energyConsumption" />
                          <br />
                          运动时间:
                          <input style="width: 50mm" v-model="stable.time" />
                          运动频率:
                          <input style="width: 60mm" v-model="stable.frequency" />
                          <br />
                          运动强度:
                          <input style="width: 128mm" v-model="stable.intensity" />
                        </td>
                      </tr> -->

                      <tr class="plan" style="text-align: center">
                        <td style="width: 30mm">适应期</td>
                        <!-- <td colspan="7">
                          目标能耗:
                          <input style="width: 50mm" v-model="adapt.energyConsumption" />
                          运动频率:
                          <input style="width: 50mm" v-model="adapt.frequency" />
                          <br />
                          运动强度:
                          <input style="width: 50mm" v-model="adapt.intensity" />
                          运动时间:
                          <input style="width: 50mm" v-model="adapt.time" />
                        </td> -->
                        <td colspan="7">
                          目标能耗:
                          <input style="width: 125mm" v-model="adapt.energyConsumption" />
                          <br />
                          运动频率:
                          <input style="width: 125mm" v-model="adapt.frequency" />
                          <br />
                          运动时间:
                          <input style="width: 125mm" v-model="adapt.time" />
                          <br />
                          运动强度:
                          <!-- <input style="width: 125mm" v-model="adapt.intensity" /> -->
                          <textarea rows="2" style="width: 125mm; resize: vertical; overflow-wrap: break-word; border: none" v-model="adapt.intensity"></textarea>
                        </td>
                      </tr>

                      <tr class="plan" style="text-align: center">
                        <td style="width: 30mm">强化期</td>
                        <!-- <td colspan="7">
                          目标能耗:
                          <input style="width: 50mm" v-model="reinforcement.energyConsumption" />
                          运动频率:
                          <input style="width: 50mm" v-model="reinforcement.frequency" />
                          <br />
                          运动强度:
                          <input style="width: 50mm" v-model="reinforcement.intensity" />
                          运动时间:
                          <input style="width: 50mm" v-model="reinforcement.time" />
                        </td> -->
                        <td colspan="7">
                          目标能耗:
                          <input style="width: 125mm" v-model="reinforcement.energyConsumption" />
                          <br />
                          运动频率:
                          <input style="width: 125mm" v-model="reinforcement.frequency" />
                          <br />
                          运动时间:
                          <input style="width: 125mm" v-model="reinforcement.time" />
                          <br />
                          运动强度:
                          <!-- <input style="width: 125mm" v-model="reinforcement.intensity" /> -->
                          <textarea rows="2" style="width: 125mm; resize: vertical; overflow-wrap: break-word; border: none" v-model="reinforcement.intensity"></textarea>
                        </td>
                      </tr>

                      <tr class="plan" style="text-align: center">
                        <td style="width: 30mm">稳定期</td>
                        <!-- <td colspan="7">
                          目标能耗:
                          <input style="width: 50mm" v-model="stable.energyConsumption" />
                          运动频率:
                          <input style="width: 50mm" v-model="stable.frequency" />
                          <br />
                          运动强度:
                          <input style="width: 50mm" v-model="stable.intensity" />
                          运动时间:
                          <input style="width: 50mm" v-model="stable.time" />
                        </td> -->
                        <td colspan="7">
                          目标能耗:
                          <input style="width: 125mm" v-model="stable.energyConsumption" />
                          <br />
                          运动频率:
                          <input style="width: 125mm" v-model="stable.frequency" />

                          <br />
                          运动时间:
                          <input style="width: 125mm" v-model="stable.time" />
                          <br />
                          运动强度:
                          <!-- <input style="width: 125mm" v-model="stable.intensity" /> -->
                          <textarea rows="2" style="width: 125mm; resize: vertical; overflow-wrap: break-word; border: none" v-model="stable.intensity"></textarea>
                        </td>
                      </tr>

                      <tr style="text-align: left">
                        <td colspan="8">
                          <div>
                            <div style="margin: 0 5mm" v-for="index in 3" :key="index">
                              {{ formData.specialNotes[index - 1] }}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <!-- 签名 -->
                  <div class="signature">
                    <!-- <p>运动处方师: {{ formData.doctor }}</p> -->
                    <p>
                      运动处方师:
                      <input v-model="formData.doctor" style="width: 25mm; border: 0px; text-align: left" />
                    </p>
                    <p style="margin-right: 0mm">
                      回访时间:
                      <input v-model="formData.followUpDate" style="width: 30mm; border: 0px; text-align: left" />
                    </p>
                  </div>
                </div>
              </div>
              <div class="pdf-options">
                <div>
                  <el-form label-width="120px">
                    <el-form-item label="文件名称">
                      <el-input v-model="pdfOptions.filename" placeholder="请输入文件名称"></el-input>
                    </el-form-item>
                    <el-form-item label="页面方向">
                      <el-radio-group v-model="pdfOptions.jsPDF.orientation">
                        <el-radio label="portrait">纵向</el-radio>
                        <!-- <el-radio label="landscape">横向</el-radio> -->
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="页面尺寸">
                      <el-select v-model="pdfOptions.jsPDF.format" placeholder="请选择页面尺寸">
                        <el-option label="A4 (210×297mm)" value="a4"></el-option>
                        <!-- <el-option label="A5 (148×210mm)" value="a5"></el-option>
              <el-option label="Letter (216×279mm)" value="letter"></el-option>
                      <el-option label="自定义" value="custom"></el-option>-->
                      </el-select>
                    </el-form-item>
                    <el-form-item label="边距(mm)" v-if="pdfOptions.jsPDF.format === 'custom'">
                      <el-input-number v-model="pdfOptions.margin" :min="0" :max="50"></el-input-number>
                    </el-form-item>
                  </el-form>
                  <div style="text-align: right">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="generatePDF">生成PDF</el-button>
                  </div>
                </div>

                <div style="width: 100%">
                  <div @click="createExercisePrescription()" style="width: 70%; margin: 0 auto; margin-top: 30px; padding: 15px; border-radius: 8px; text-align: center; background-color: #2a82e4; color: #fff">重新生成运动处方</div>
                </div>

                <div class="dateRecord">
                  <div style="margin-bottom: 20px">运动处方记录</div>
                  <div style="display: flex; padding-left: 20%" v-for="(item, index) in reportDateList" :key="index">
                    <div class="clickDate" @click="getExercisePrescriptionByReportId(item.wxUserId, item.id)">{{ item.reportDate }} 运动处方</div>
                    <div class="clickDateDelete" @click="deleteExercisePrescription(item.wxUserId, item.id)">x</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div class="week">
          <div class="side">一周运动方案</div>
          <div class="content">
            <div class="title">
              <div :class="weekTap == '日' ? 'active' : ''" @click="weekChange('日')">周日</div>
              <div :class="weekTap == '一' ? 'active' : ''" @click="weekChange('一')">周一</div>
              <div :class="weekTap == '二' ? 'active' : ''" @click="weekChange('二')">周二</div>
              <div :class="weekTap == '三' ? 'active' : ''" @click="weekChange('三')">周三</div>
              <div :class="weekTap == '四' ? 'active' : ''" @click="weekChange('四')">周四</div>
              <div :class="weekTap == '五' ? 'active' : ''" @click="weekChange('五')">周五</div>
              <div :class="weekTap == '六' ? 'active' : ''" @click="weekChange('六')">周六</div>
            </div>
            <div class="tent">
              <div class="exercise" v-for="item in exerciseInfo" :key="item.name">
                <div>{{ item.name }}</div>
                <div>{{ item.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <el-button type="primary" @click="dialogVisible = true">生成PDF</el-button>
    <el-dialog title="生成PDF选项" :visible.sync="dialogVisible" width="340mm" class="my-dialog-class" :top="'1%'">
    </el-dialog>-->
    <!-- <div class="pdf-container">
    </div>-->
  </div>
</template>

<script>
import { getMotion, getBodyDate, getUserJkDetail, getExerciseSchemeNew, getExercisePrescription, getExercisePrescriptionReportList, getExercisePrescriptionByReportId, createExercisePrescription, deleteExercisePrescription } from "@/api/health/manage";
import { mapGetters } from "vuex";
import html2pdf from "html2pdf.js";
import func from "@/util/func";

export default {
  data() {
    return {
      wxUserId: this.$route.query.wxUserId,
      info: {},
      form: {},
      schemeExercise: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      data: [],
      showDialog: false, // 控制弹框显示
      dialogVisible: false,
      formData: {
        // name: "",
        // gender: "女",
        // age: 43,
        // phone: "153****8212",
        // idNumber: "320111198202*****",
        medicalHistory: "",
        medication: "",

        height: 162,
        weight: 86.9,
        activityLevel: 0,
        ydfxdj: 0,
        xfgn: 0,
        jrll: 0,
        tcf: 0,
        jdxt: 0,
        tzxz: 0,
        jdxy: 0,
        jz: 0,
        zjxfnl: 0,
        zjjrll: 0,
        zjstrrx: 0,
        jgydxm: 3,
        exercisePurposes: ["降低血压", "调整血脂", "降低血糖", "减重", "增加心肺活力"],
        institutionExercises: [
          {
            name: "二头/三头肌训练",
            level: "1档",
            sets: "4组",
            reps: "21个/组",
          },
          {
            name: "水瓶直筒侧平举",
            level: "2档",
            sets: "4组",
            reps: "24个/组",
          },
        ],
        notes: ["饭前饭后1小时内尽量不要运动", "锻炼后不应立即入浴、大汗淋漓时通低温，会使皮肤表层收缩，严重时引起闭汗症或静脉曲张"],
        doctor: "",
        followUpDate: new Date().toLocaleDateString(),
      },
      pdfOptions: {
        margin: 10,
        filename: "运动处方.pdf",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      },
      weekTap: 1,
      chuFshow: 1,
      exerciseInfo: [],
      exercisePrescription: {},
      homeMotion: [
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
      ],
      mechanismMotion: [
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
      ],
      frequency: ["", "", "", "", "", "", "", "", ""],
      time: ["", "", "", "", "", "", "", "", ""],
      group: ["", "", "", "", "", "", "", "", ""],
      num: ["", "", "", "", "", "", "", "", ""],
      adapt: {},
      reinforcement: {},
      stable: {},
      specialNotes: ["", "", "", "", "", "", "", "", ""],
      sportsPurposes: [],
      cardiopulmonaryFunction: 0,
      muscleFunction: 0,
      bodyFunction: 0,
      reportDateList: [],
      reportDate: "",
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  created() {
    // this.onLoad()
    this.getweek();
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      const wxUserId = this.$route.query.wxUserId;
      this.formData.followUpDate = new Date(new Date().setMonth(new Date().getMonth() + 3)).toLocaleDateString();

      getMotion(wxUserId).then((res) => {
        this.data = res.data;
        this.pdfOptions.filename = "运动处方_" + res.data[0].name;
        this.formData.name = res.data[0].name;
        this.formData.age = res.data[0].age;
        if (res.data[0].sex === 2) this.formData.gender = "女";
        else if (res.data[0].sex === 1) this.formData.gender = "男";
        this.formData.phone = res.data[0].mobile;
        this.formData.idNumber = res.data[0].id_card;
        this.formData.height = res.data[0].height;
        this.formData.weight = res.data[0].weight;
      });

      getBodyDate(wxUserId).then((res) => {
        this.body = res.data.medicalExaminationReport;
      });

      getUserJkDetail(wxUserId).then((res) => {
        const wxUserId = window.localStorage.getItem("pcUserId");
        if (wxUserId === "2043870969731301377") {
          res.data.userJk.name = func.maskName(res.data.userJk.name);
          res.data.userJk.mobile = func.maskPhone(res.data.userJk.mobile);
        }
        this.info = res.data.userJk;
        if (this.info.sex === 1) this.info.gender = "男";
        else if (this.info.sex === 2) this.info.gender = "女";
      });

      getExerciseSchemeNew(wxUserId).then((res) => {
        this.schemeExercise = res.data;
        if (!this.schemeExercise.specialNotes) {
          this.schemeExercise.specialNotes = ["-", "-", "-"];
        }
        const exerciseInfo = [
          {
            name: "运动类型",
            value: this.schemeExercise.schemeExerciseNew.sevenExerciseType,
          },
          {
            name: "推荐项目",
            value: this.schemeExercise.schemeExerciseNew.sevenExerciseRecommend,
          },
        ];
        this.exerciseInfo = exerciseInfo;
        this.weekTap = "日";
      });

      getExercisePrescription(wxUserId).then((res) => {
        this.homeMotion = [
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
        ];
        this.mechanismMotion = [
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
          {
            motionName: "",
            motionFrequency: "",
            motionTime: "",
          },
        ];
        console.log("getExercisePrescription", res.data);
        const formData = this.formData;
        const exercisePrescription = res.data;
        formData.bs = exercisePrescription.bs ? exercisePrescription.bs + " mmol/L" : "";
        formData.bp = exercisePrescription.bp ? exercisePrescription.bp + " mmHg" : "";
        formData.hr = exercisePrescription.hr ? exercisePrescription.hr + " bpm" : "";
        formData.cho = exercisePrescription.cho ? exercisePrescription.cho + " mmol/L" : "";
        formData.fat_rate = exercisePrescription.fat_rate ? exercisePrescription.fat_rate + "%" : "";
        formData.fat = exercisePrescription.fat ? exercisePrescription.fat + " kg" : "";
        formData.slm = exercisePrescription.slm ? exercisePrescription.slm + " kg" : "";
        formData.vfa = exercisePrescription.vfa ? exercisePrescription.vfa + " cm²" : "";
        for (let i = 0; i < exercisePrescription.homeMotion.length; i++) {
          this.homeMotion[i] = exercisePrescription.homeMotion[i];
        }
        for (let i = 0; i < exercisePrescription.mechanismMotion.length; i++) {
          this.mechanismMotion[i] = exercisePrescription.mechanismMotion[i];
        }
        this.adapt = exercisePrescription.adapt || "";
        this.reinforcement = exercisePrescription.reinforcement || "";
        this.stable = exercisePrescription.stable || "";
        this.specialNotes = exercisePrescription.specialNotes || "";
        this.sportsPurposes = exercisePrescription.sportsPurposes || "";
        formData.ydfxdj = exercisePrescription.riskLevel;
        formData.purposes = res.data.purposes || "";
        formData.xfgn = exercisePrescription.function.cardiopulmonaryFunction;
        formData.jrll = exercisePrescription.function.muscleFunction;
        formData.tcf = exercisePrescription.function.bodyFunction;
        let drug = "";
        if (exercisePrescription.drugPlanList.length !== 0) drug = exercisePrescription.drugPlanList.map((item) => item.drugName).join("\n");
        formData.drug = drug;
        formData.activityLevel = exercisePrescription.activityLevel;

        formData.frequency = exercisePrescription.frequency;
        formData.strength = exercisePrescription.strength;
        formData.time = exercisePrescription.time;
        if (!exercisePrescription.specialNotes) {
          exercisePrescription.specialNotes = ["-", "-", "-"];
        }
        formData.specialNotes = res.data.specialNotes;

        this.reportDate = res.data.reportDate;

        console.log("formData", formData);

        this.formData = formData;
      });

      this.getExercisePrescriptionReportList(wxUserId);
    },

    getExercisePrescriptionReportList(wxUserId) {
      getExercisePrescriptionReportList(wxUserId).then((res) => {
        if (res.success) {
          this.reportDateList = res.data;
        }
      });
    },

    getExercisePrescriptionByReportId(wxUserId, reportId) {
      this.homeMotion = [
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
      ];
      this.mechanismMotion = [
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
      ];
      getExercisePrescriptionByReportId(wxUserId, reportId).then((res) => {
        console.log(res.data);
        console.log("getExercisePrescription", res.data);
        const formData = this.formData;
        const exercisePrescription = res.data;
        formData.bs = exercisePrescription.bs ? exercisePrescription.bs + " mmol/L" : "";
        formData.bp = exercisePrescription.bp ? exercisePrescription.bp + " mmHg" : "";
        formData.hr = exercisePrescription.hr ? exercisePrescription.hr + " bpm" : "";
        formData.cho = exercisePrescription.cho ? exercisePrescription.cho + " mmol/L" : "";
        formData.fat_rate = exercisePrescription.fat_rate ? exercisePrescription.fat_rate + "%" : "";
        formData.fat = exercisePrescription.fat ? exercisePrescription.fat + " kg" : "";
        formData.slm = exercisePrescription.slm ? exercisePrescription.slm + " kg" : "";
        formData.vfa = exercisePrescription.vfa ? exercisePrescription.vfa + " cm²" : "";
        for (let i = 0; i < exercisePrescription.homeMotion.length; i++) {
          this.homeMotion[i] = exercisePrescription.homeMotion[i];
        }
        for (let i = 0; i < exercisePrescription.mechanismMotion.length; i++) {
          this.mechanismMotion[i] = exercisePrescription.mechanismMotion[i];
        }
        this.adapt = exercisePrescription.adapt || "";
        this.reinforcement = exercisePrescription.reinforcement || "";
        this.stable = exercisePrescription.stable || "";
        this.specialNotes = exercisePrescription.specialNotes || "";
        this.sportsPurposes = exercisePrescription.sportsPurposes || "";
        formData.ydfxdj = exercisePrescription.riskLevel;
        formData.purposes = res.data.purposes || "";
        formData.xfgn = exercisePrescription.function.cardiopulmonaryFunction;
        formData.jrll = exercisePrescription.function.muscleFunction;
        formData.tcf = exercisePrescription.function.bodyFunction;
        let drug = "";
        if (exercisePrescription.drugPlanList.length !== 0) drug = exercisePrescription.drugPlanList.map((item) => item.drugName).join("\n");
        formData.drug = drug;
        formData.activityLevel = exercisePrescription.activityLevel;

        formData.frequency = exercisePrescription.frequency;
        formData.strength = exercisePrescription.strength;
        formData.time = exercisePrescription.time;
        if (!exercisePrescription.specialNotes) {
          exercisePrescription.specialNotes = ["-", "-", "-"];
        }
        formData.specialNotes = res.data.specialNotes;

        this.reportDate = res.data.reportDate;

        this.formData = formData;
      });
    },

    createExercisePrescription() {
      console.log(this.wxUserId);
      this.homeMotion = [
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
      ];
      this.mechanismMotion = [
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
        {
          motionName: "",
          motionFrequency: "",
          motionTime: "",
        },
      ];
      createExercisePrescription(this.wxUserId).then((res) => {
        console.log(res.data);
        console.log("getExercisePrescription", res.data);
        const formData = this.formData;
        const exercisePrescription = res.data;
        formData.bs = exercisePrescription.bs ? exercisePrescription.bs + " mmol/L" : "";
        formData.bp = exercisePrescription.bp ? exercisePrescription.bp + " mmHg" : "";
        formData.hr = exercisePrescription.hr ? exercisePrescription.hr + " bpm" : "";
        formData.cho = exercisePrescription.cho ? exercisePrescription.cho + " mmol/L" : "";
        formData.fat_rate = exercisePrescription.fat_rate ? exercisePrescription.fat_rate + "%" : "";
        formData.fat = exercisePrescription.fat ? exercisePrescription.fat + " kg" : "";
        formData.slm = exercisePrescription.slm ? exercisePrescription.slm + " kg" : "";
        formData.vfa = exercisePrescription.vfa ? exercisePrescription.vfa + " cm²" : "";
        for (let i = 0; i < exercisePrescription.homeMotion.length; i++) {
          this.homeMotion[i] = exercisePrescription.homeMotion[i];
        }
        for (let i = 0; i < exercisePrescription.mechanismMotion.length; i++) {
          this.mechanismMotion[i] = exercisePrescription.mechanismMotion[i];
        }
        this.adapt = exercisePrescription.adapt || "";
        this.reinforcement = exercisePrescription.reinforcement || "";
        this.stable = exercisePrescription.stable || "";
        this.specialNotes = exercisePrescription.specialNotes || "";
        this.sportsPurposes = exercisePrescription.sportsPurposes || "";
        formData.ydfxdj = exercisePrescription.riskLevel;
        formData.purposes = res.data.purposes || "";
        formData.xfgn = exercisePrescription.function.cardiopulmonaryFunction;
        formData.jrll = exercisePrescription.function.muscleFunction;
        formData.tcf = exercisePrescription.function.bodyFunction;
        let drug = "";
        if (exercisePrescription.drugPlanList.length !== 0) drug = exercisePrescription.drugPlanList.map((item) => item.drugName).join("\n");
        formData.drug = drug;
        formData.activityLevel = exercisePrescription.activityLevel;

        formData.frequency = exercisePrescription.frequency;
        formData.strength = exercisePrescription.strength;
        formData.time = exercisePrescription.time;
        if (!exercisePrescription.specialNotes) {
          exercisePrescription.specialNotes = ["-", "-", "-"];
        }
        formData.specialNotes = res.data.specialNotes;

        this.reportDate = res.data.reportDate;

        this.formData = formData;

        this.getExercisePrescriptionReportList(this.wxUserId);
      });

      //  this.getExercisePrescriptionReportList(this.wxUserId);
    },

    deleteExercisePrescription(wxUserId, reportId) {
      deleteExercisePrescription(reportId).then((res) => {
        this.getExercisePrescriptionReportList(wxUserId);
      });
    },

    chickActivityLevel(index) {
      this.formData.activityLevel = Number(index);
    },

    ydfxdj(index) {
      this.formData.ydfxdj = Number(index);
    },

    xfgn(index) {
      this.formData.xfgn = Number(index);
    },

    jrll(index) {
      this.formData.jrll = Number(index);
    },

    tcf(index) {
      this.formData.tcf = Number(index);
    },

    ydmd(index) {
      index = Number(index);
      switch (index) {
        case 1:
          if (this.formData.jdxy === 1) this.formData.jdxy = 0;
          else this.formData.jdxy = 1;
          break;
        case 2:
          if (this.formData.tzxz === 1) this.formData.tzxz = 0;
          else this.formData.tzxz = 1;
          break;
        case 3:
          if (this.formData.jdxt === 1) this.formData.jdxt = 0;
          else this.formData.jdxt = 1;
          break;
        case 4:
          if (this.formData.jz === 1) this.formData.jz = 0;
          else this.formData.jz = 1;
          break;
        case 5:
          if (this.formData.zjxfnl === 1) this.formData.zjxfnl = 0;
          else this.formData.zjxfnl = 1;
          break;
        case 6:
          if (this.formData.zjjrll === 1) this.formData.zjjrll = 0;
          else this.formData.zjjrll = 1;
          break;
        case 7:
          if (this.formData.zjstrrx === 1) this.formData.zjstrrx = 0;
          else this.formData.zjstrrx = 1;
          break;
      }
    },

    jgydxm(index) {
      this.formData.jgydxm = Number(index);
    },

    generatePDF() {
      this.showDialog = false; // 关闭弹框
      const element = document.getElementById("pdf-content");

      const opt = {
        margin: 0,
        filename: this.pdfOptions.filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        pagebreak: { mode: ["css", "legacy"], before: ".motion-project-page-spacer" },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      html2pdf().from(element).set(opt).save();
    },

    getweek() {
      const days = ["日", "一", "二", "三", "四", "五", "六"];
      const date = new Date();
      const dayOfWeek = days[date.getDay()];
      this.weekChange(dayOfWeek);
    },

    changeChuF(id) {
      this.chuFshow = id;
    },

    weekChange(id) {
      this.weekTap = id;
      let exerciseInfo = [];
      switch (id) {
        case "一":
          exerciseInfo = [
            {
              name: "运动类型",
              value: this.schemeExercise.schemeExerciseNew.oneExerciseType,
            },
            {
              name: "推荐项目",
              value: this.schemeExercise.schemeExerciseNew.oneExerciseRecommend,
            },
          ];
          this.exerciseInfo = exerciseInfo;
          break;
        case "二":
          exerciseInfo = [
            {
              name: "运动类型",
              value: this.schemeExercise.schemeExerciseNew.twoExerciseType,
            },
            {
              name: "推荐项目",
              value: this.schemeExercise.schemeExerciseNew.twoExerciseRecommend,
            },
          ];
          this.exerciseInfo = exerciseInfo;
          break;
        case "三":
          exerciseInfo = [
            {
              name: "运动类型",
              value: this.schemeExercise.schemeExerciseNew.threeExerciseType,
            },
            {
              name: "推荐项目",
              value: this.schemeExercise.schemeExerciseNew.threeExerciseRecommend,
            },
          ];
          this.exerciseInfo = exerciseInfo;
          break;
        case "四":
          exerciseInfo = [
            {
              name: "运动类型",
              value: this.schemeExercise.schemeExerciseNew.fourExerciseType,
            },
            {
              name: "推荐项目",
              value: this.schemeExercise.schemeExerciseNew.fourExerciseRecommend,
            },
          ];
          this.exerciseInfo = exerciseInfo;
          break;
        case "五":
          exerciseInfo = [
            {
              name: "运动类型",
              value: this.schemeExercise.schemeExerciseNew.fiveExerciseType,
            },
            {
              name: "推荐项目",
              value: this.schemeExercise.schemeExerciseNew.fiveExerciseRecommend,
            },
          ];
          this.exerciseInfo = exerciseInfo;
          break;
        case "六":
          exerciseInfo = [
            {
              name: "运动类型",
              value: this.schemeExercise.schemeExerciseNew.sixExerciseType,
            },
            {
              name: "推荐项目",
              value: this.schemeExercise.schemeExerciseNew.sixExerciseRecommend,
            },
          ];
          this.exerciseInfo = exerciseInfo;
          break;
        case "日":
          exerciseInfo = [
            {
              name: "运动类型",
              value: this.schemeExercise.schemeExerciseNew.sevenExerciseType,
            },
            {
              name: "推荐项目",
              value: this.schemeExercise.schemeExerciseNew.sevenExerciseRecommend,
            },
          ];
          this.exerciseInfo = exerciseInfo;
          break;
      }
    },
    click(index) {
      let path = "";
      switch (index) {
        case 0:
          // path = '/agent/digitalarchive'
          path = "/agent/dataarchive";
          break;
        case 1:
          path = "/agent/lossWeightBodyData";
          break;
        case 2:
          path = "/agent/homeMotion";
          break;
        case 3:
          path = "/agent/lossWeightClinicalExercise";
          break;
        case 4:
          path = "/agent/lossWeightCognitivebehaviorald";
          break;
        case 5:
          path = "/agent/lossWeightDrug";
          break;
        case 6:
          path = "/agent/lossWeightFollow";
          break;
      }
      const parameter = {
        wxUserId: this.wxUserId,
      };
      this.$router.push({
        path: path,
        query: parameter,
      });
    },

    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: "/agent/weightLoss",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 重置所有继承属性 */
.style-isolation {
  all: initial;
}

/* 重置内部所有元素 */
.style-isolation * {
  all: unset;
}

.tr {
  vertical-align: middle;
  display: table-row;
  vertical-align: inherit;
  unicode-bidi: isolate;
  border-color: inherit;
}

.my-dialog-class {
  display: flex;
  align-items: flex-start;
}

.prescription-container {
  /* font-family: "SimSun", "宋体", serif; */
  width: 210mm;
  // height: 296mm;
  padding: 0mm 10mm;
  box-sizing: border-box;
  // float: left;
  font-family: Segoe UI, PingFang SC, Microsoft YaHei, sans-serif;
  border: 1px solid #000;
  line-height: 1.4;
}

input {
  border: 0px;
  line-height: 1.5;
  text-align: center;
}

.pdf-options {
  padding-left: 2%;
  // float: left;
  width: 120mm;
}

h1 {
  text-align: center;
  font-size: 24px;
  /* margin-bottom: 20px; */
  color: #0066cc;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0px;
}

.info-table td {
  border: 1px solid #000;
  padding: 1mm;
  font-size: 14px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0px;
}

.motion-project-page-spacer {
  break-before: page;
  page-break-before: always;
  height: 8mm;
}

.motion-project-table {
  break-inside: avoid;
  page-break-inside: avoid;
}

.data-table td {
  border: 1px solid #000;
  padding: 1mm;
  font-size: 13px;
}

.model {
  margin-bottom: 0px;
}

h2 {
  font-size: 16px;
  color: #0066cc;
  border-bottom: 1px solid #e0e0e0;
  box-sizing: border-box;
}

h3 {
  font-size: 18px;
  margin: 10px 0;
  border-bottom: 1px solid #000;
  padding-bottom: 5px;
}

ul,
ol {
  margin-left: 20px;
}

.signature {
  text-align: right;
}

p {
  margin-bottom: 0px;
  /* line-height: 1.7; */
}

template {
  all: initial;
}

.card {
  display: flex;
}

.left {
  width: 20%;
}

.person {
  width: 100%;
  height: 50vh;
  background-color: #ffffff;
  border-radius: 12px;
  margin-top: 10px;

  .title {
    width: 100%;
    height: 26%;
    background-color: #409eff;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  .img {
    width: 40%;
    height: auto;
    margin: 0 auto;
    border-radius: 12px;
    margin-top: -25%;
    background-color: #ffffff;
    display: flex;
    justify-items: center;
    justify-content: center;
    padding: 4% 0;

    div {
      width: 80%;
      background-color: #409eff;
      border-radius: 12px;
      display: flex;
      justify-items: center;
      justify-content: center;
      padding: 18% 0;

      img {
        width: 50%;
        height: auto;
      }
    }
  }

  .name {
    width: 100%;
    text-align: center;
    font-size: 28px;
    color: #101010;
    font-weight: bold;
  }

  .body {
    padding: 5%;
    height: 50%;

    .th {
      display: flex;
      width: 95%;
      font-size: 16px;
      line-height: 40px;

      .td {
        width: 40%;
        // text-align: right;
      }

      .tr {
        overflow: hidden;
        /* 隐藏溢出内容 */
        text-overflow: ellipsis;
        /* 溢出时显示省略号 */
        white-space: nowrap;
        /* 强制文本在一行内显示 */
      }
    }
  }
}

.plan {
  width: 100%;
  padding-bottom: 20px;
  background-color: #ffffff;
  border-radius: 12px;
  margin-top: 16px;
  border: 0.5px solid #bbb094;

  .title {
    height: 12%;
    background-color: #bbb094;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    display: flex;
    justify-items: center;
    padding: 4%;

    img {
      width: 30px;
      height: 30px;
    }

    div {
      line-height: 30px;
      color: #fff;
      font-size: 18px;
      margin-left: 10px;
    }
  }

  .body {
    padding: 4%;
    color: #b2a073;
    font-size: 14px;

    div {
      margin-top: 5px;
      line-height: 24px;
    }
  }
}

.right {
  width: 80%;
  padding: 10px 20px;
}

.chuF {
  width: 90%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 2%;

  .title {
    display: flex;

    div {
      width: 12%;
      height: 40px;
      line-height: 40px;
      border: 1px solid #666666;
      text-align: center;
      color: #666666;
      border-radius: 24px;
      margin-right: 2%;
    }

    .active {
      background-color: #409eff;
      color: #fff;
      border: none;
    }
  }

  .content {
    width: 100%;

    .name {
      height: 45px;
      padding: 10px 0;
      display: flex;
      margin-top: 10px;

      .icon {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin: 5px 10px 0 0;
      }

      .h1 {
        background-color: #409eff;
      }

      .h2 {
        background-color: #fe62e7;
      }

      .h3 {
        background-color: #ff9037;
      }

      .h4 {
        background-color: #43d87f;
      }

      .h5 {
        background-color: #bb68fc;
      }

      .dt {
        color: #0f1021;
        font-size: 16px;
      }
    }

    .card {
      border-left: 1px solid #e6e6e6;
      padding: 0 20px;
      margin-left: 5px;
      color: #666666;
      font-size: 14px;
      line-height: 20px;
    }
  }
}

.week {
  width: 90%;
  background-color: #ffffff;
  border-radius: 12px;
  margin-top: 16px;
  display: flex;

  .side {
    font-size: 25px;
    background-color: red;
    width: 5%;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    writing-mode: vertical-lr;
    /* 从左到右的垂直文本 */
    letter-spacing: 8px;
    padding-left: 1%;
    text-align: center;
    background-color: #409eff;
    color: #fff;
  }

  .content {
    width: 95%;
    padding: 2% 4%;

    .title {
      width: 100%;
      display: flex;
      justify-content: space-between;

      div {
        width: 5%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #aaa6c8;
        border-radius: 12px;
      }

      .active {
        background-color: #409eff;
        color: #fff;
      }
    }

    .tent {
      display: flex;
      justify-content: space-between;
      margin: 20px 10% 0 10%;

      .exercise {
        width: 40%;
        padding: 16px 2%;
        border: 1px solid #aaa6c8;
        border-radius: 12px;
        background-color: #f0f8ff;
        color: #666666;
        font-size: 14px;
        line-height: 24px;

        div:first-child {
          width: 100%;
          margin-bottom: 5px;
          font-size: 16px;
          font-weight: 600;
        }

        text-align: center;
        min-height: 150px;
      }
    }
  }
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom: 2px;
}

.healthActive {
  border-bottom: 3px solid #409eff;
  color: #409eff;
  font-weight: bold;
}

.plan input {
  text-align: left;
}

.clickDate {
  width: 70%;
  text-align: center;
  margin: 0px 0;
  padding: 10px 0px;
  color: #2980b9;
  transform: skew(-15deg);
}

.clickDate:hover {
  text-decoration: underline;
  background-color: rgba(52, 152, 219, 0.1);
}

.clickDateDelete {
  width: 30%;
  text-align: center;
  margin: 0px 0;
  padding: 15px 0 0 0;
  color: #2980b9;
  font-size: 12px;
  transform: skew(-15deg);
}

.clickDateDelete:hover {
  text-decoration: underline;
  background-color: rgba(52, 152, 219, 0.1);
}

.dateRecord {
  padding: 20px;
}
</style>
